import { Checkbox } from "@/components/ui/checkbox";
import { useTr } from "@/lib/tr";

export function LanguagePicker({ languages = [], mode, value, onChange }) {
  const tr = useTr();
  const setMode = (m) => onChange(m, m === "all" ? languages.map((l) => l.code) : value);
  const toggle = (c) => onChange("selected", value.includes(c) ? value.filter((x) => x !== c) : [...value, c]);
  const opt = (m, label) => (
    <button type="button" onClick={() => setMode(m)} data-testid={`lang-mode-${m}`}
      className={`rounded-full px-4 py-1.5 text-xs font-medium transition-colors ${mode === m ? "bg-accent text-white" : "border border-slate-700 text-slate-300 hover:bg-slate-800"}`}>{label}</button>
  );
  return (
    <div data-testid="language-picker">
      <div className="flex flex-wrap gap-2">
        {opt("all", tr("Toutes les langues", "All languages"))}
        {opt("selected", tr("Sélectionner les langues", "Select languages"))}
      </div>
      {mode === "selected" && (
        <div className="mt-3 flex flex-wrap gap-4">
          {languages.map((l) => (
            <label key={l.code} className="flex cursor-pointer items-center gap-2 text-sm text-slate-300">
              <Checkbox checked={value.includes(l.code)} onCheckedChange={() => toggle(l.code)} data-testid={`agent-lang-${l.code}`} /> {l.label}
            </label>
          ))}
        </div>
      )}
      {mode === "selected" && !value.length && <p className="mt-2 text-xs text-amber-300">{tr("Aucune langue : l'agent ne verra aucun ticket.", "No language: the agent will see no tickets.")}</p>}
    </div>
  );
}
